<template>
    <div class="info-box" id="">
        <div class="name">水稻</div>
        <div class="info-item">当前区域种植面积：<span style="color:rgba(1, 194, 255, 1)">12</span>公顷 </div>
        <div class="info-item">当前作物种植总面积：<span style="color:rgba(1, 194, 255, 1)">125</span>公顷 </div>
        <div class="info-item">作物总产量：<span style="color:rgba(255, 195, 0, 1)">1258</span>斤 </div>
        <div class="info-item">作物总产值：<span style="color:rgba(255, 141, 26, 1)">125899</span>元 </div>
        <div class="info-item">板块地址：四川省稻香渔歌</div>
    </div>
</template>
<script>
export default {
  name: '',

  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
}
</script>
<style lang="less" scoped>
.info-box{
    width: 286px;
    height: 250px;
    background: url("~@/assets/images/info_box.png");
    background-size: 100% 100%;
    padding: 16px 24px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .name{
        font-size: 16px;
        font-weight: 700;
        color: rgba(1, 194, 255, 1);
        text-align: center;
        letter-spacing: 1px;
        margin-bottom: 6px;
    }
    .info-item{
        font-size: 14px;
        line-height: 25px;
        color: rgba(222, 240, 255, 1);
        span{
            margin-right: 4px;
            font-weight: 600;
        }
    }
}
</style>
